export const PAGE = 'TabellaDettaglio'
export const OUTPUT_NAME = 'tabellaDettaglio'
export const TITLE = `${PAGE}.TITLE`

export const STORE_KEY = 'DetailTable'

export const TOTAL_ROWS_LIMIT = 150000

export const DEFAULT_PAGE_SIZE = 10

export const tableLabels = {
  AREA: `${PAGE}.Table.AREA`,
  CLUSTER: `${PAGE}.Table.CLUSTER`,
  CONTRACT: `${PAGE}.Table.CONTRACT`,
  STORE: `${PAGE}.Table.STORE`,
  ZONE: `${PAGE}.Table.ZONE`,
  CATEGORY: `${PAGE}.Table.CATEGORY`,
  SEASON: `${PAGE}.Table.SEASON`,
  APC: `${PAGE}.Table.APC`,
  SUBCATEGORY: `${PAGE}.Table.SUBCATEGORY`,
  FUNCTION: `${PAGE}.Table.FUNCTION`,
  ARTICLE: `${PAGE}.Table.ARTICLE`,
  HYP: `${PAGE}.Table.HYPOTHESIS`,
  ACTION: `${PAGE}.Table.ACTION`,
  QUANTITY: `${PAGE}.Table.QUANTITY`,
  VALUE: `${PAGE}.Table.VALUE`,
  RESTORES: `${PAGE}.Table.RESTORES`
}
